import React from "react";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebaseApp from "lib/firebase-provider/firebaseApp";
import * as firebase from "firebase/app";

import { Link, Typography } from "@material-ui/core";

import { Trans } from "react-i18next";

import { useLocation, useHistory } from "react-router-dom";

// Configure FirebaseUI.
const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: "popup",
  // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  // signInSuccessUrl: "/distancing",
  autoUpgradeAnonymousUsers: false,
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
  ],
};

export default function LoginPage() {
  const location = useLocation();
  const history = useHistory();

  const signInSuccessUrl = location?.state?.successUrl || "/";

  return (
    <>
      <Trans i18nKey="login.body">
        <Typography gutterBottom align="justify" variant="body2">
          Regístrate para acceder a la información detallada de Estados y
          Municipios. Te vamos a estar contactando para comunicarte mejoras de
          la plataforma y nuevas herramientas. Si deseas comunicarte con
          nosotros, escríbenos a{" "}
          <b>
            <Link href="mailto:info@grandata.com">info@grandata.com</Link>
          </b>
          .
        </Typography>
      </Trans>

      <StyledFirebaseAuth
        uiConfig={{
          ...uiConfig,
          callbacks: {
            signInSuccessWithAuthResult: () => {
              history.push(signInSuccessUrl);
            },
          },
        }}
        firebaseAuth={firebaseApp.auth()}
      />
    </>
  );
}
